import { defineMessages } from 'react-intl'

export default defineMessages({
  pageCount: {
    id: 'components.EmbeddedPdf.pageCount',
    defaultMessage: 'Page {pageNumber} of {numPages}',
  },
  next: {
    id: 'components.EmbeddedPdf.next',
    defaultMessage: 'Next',
  },
  previous: {
    id: 'components.EmbeddedPdf.previous',
    defaultMessage: 'Previous',
  },
  loading: {
    id: 'components.EmbeddedPdf.loading',
    defaultMessage: 'Loading PDF...',
  },
  error: {
    id: 'components.EmbeddedPdf.error',
    defaultMessage: 'Failed to load PDF',
  },
})
